import { Grid, Typography, useTheme } from "@mui/material"
import { memo, useMemo } from "react"
import HashLoader from "react-spinners/GridLoader"
import { styles } from "./style"

const LoadingBackdrop = ({ lang }) => {
  const language = useMemo(() => lang, [lang])
  const theme = useTheme()
  const { containerStyle } = styles()

  return (
    <Grid container sx={containerStyle}>
      <HashLoader color={theme.palette.primary.main} />
      <Typography mt={2} fontSize={24} variant='body1'>
        {language === "pt" ? "Carregando..." : "Loading..."}
      </Typography>
    </Grid>
  )
}

export default memo(LoadingBackdrop)
